import * as React from "react"
import { CrossSellCarousel } from "../../../../components/crossSellCarousel";
import { CrossSell } from "../../../../components/crossSell";
import { useCollectionCarouselQuery } from "../../../../hooks/useCollectionCarouselQuery";
import { CrossSellListType } from "../../../../definitions/enums";
import { pushToDataLayer } from "../../../../hooks/useCrossSellDataLayerPush";


export const Collection = () => {
    const { name, models, carouselModel } = useCollectionCarouselQuery();

    // Initialize an empty products array
    let products: Array<{
        title: string;
        sku: string;
        price: number;
        listType: CrossSellListType.Collection;
    }> = [];


    // If there is a collection, populate the products array
    if (name || models || carouselModel) {
        products = models.map((model) => ({
            title: model.product.title,
            sku: model.product.sku,
            price: model.price.unitPrice,
            listType: CrossSellListType.Collection,
        }));

        // Push to dataLayer regardless of the bundleModel condition
        pushToDataLayer(products);
    }


    // If there is no collection, return an empty fragment
    if (!name || !models || !carouselModel) return <></>;

    // If there are no models or no carousel model, return an empty fragment
    if (!models || !carouselModel) return <></>;


    return (
        <CrossSellCarousel model={carouselModel}>
            {models.map((model, index) =>

                <CrossSell key={index} listType={CrossSellListType.Collection} model={model} index={index} />

            )}
        </CrossSellCarousel>
    )
}